<template>
    <div class="login_page">
        <el-card class="box_card">
            <div class="login_title">登录</div>
            <div class="login_form_box">
                <el-form ref="ruleForm" :model="form" :rules="rules" label-width="80px" label-position="left">
                    <el-form-item label="手机号" prop="mobile">
                        <el-input v-model="form.mobile" name="mobile" autocomplete="on"
                            style="width: 300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-input v-model="form.code" style="width: 300px;">
                            <el-button slot="append" @click="getCode">获取验证码{{
                                getingCode == 1 ? '(' + codetime + 's)' : '' }}</el-button>
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item label="验证码" prop="code">
                        <el-input v-model="form.code" style="width: 260px;"></el-input>
                    </el-form-item> -->
                    <!-- <div class="text-r">
                        <div :class="getingCode == 1 ? 'getcode_box c-gray' : 'getcode_box'" @click="getCode">获取验证码{{
                            getingCode == 1 ? '(' + codetime + 's)' : '' }}
                        </div>
                    </div> -->

                    <div class="public_btn mt-50" @click="submitForm('ruleForm')">登录</div>
                </el-form>
            </div>

        </el-card>
    </div>
</template>

<script>
import port from '@/api/port'
export default {

    data() {
        return {
            form: {
                mobile: '',
                code: '',
            },
            codetime: 59,
            getingCode: 0,
            timer: null,
            isSubmit: true,
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
            }
        }
    },
    created() {
    },
    methods: {
        getCode() {
            var that = this
            that.timer = null
            if (that.form.mobile) {
                if (!(/^1[3456789]\d{9}$/.test(that.form.mobile))) {
                    that.$message.error('请输入正确的手机号');
                } else {
                    if (that.isSubmit) {
                        that.isSubmit = false
                        port.getCode({
                            mobile: that.form.mobile
                        }).then(res => {
                            if (res.state == 1) {
                                that.getingCode = 1
                                that.timer = setInterval(function () {
                                    that.codetime = that.codetime--
                                    if (that.codetime-- <= 0) {
                                        clearInterval(that.timer);
                                        that.getingCode = 0
                                        that.codetime = '59'
                                        that.isSubmit = true
                                    }
                                }, 1000);
                            } else {
                                that.isSubmit = true
                                that.getingCode = 0
                                that.$message.error(res.error[0]);
                            }
                        })
                    }
                }
            } else {
                this.$message.error('请输入手机号');
            }
        },
        submitForm(formName) {
            var that = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    port.codeLogin(this.form).then(res => {
                        if (res.state == 1) {
                            localStorage.setItem('xthy_admin_token', res.data.access_token)
                            localStorage.setItem('xthy_admin_user_info', JSON.stringify(res.data.user))
                            this.$parent.getInit()
                        } else {
                            this.$message({
                                message: res.error[0],
                                type: 'error'
                            });
                        }
                    })
                } else {
                    return false;
                }
            });
        },

        resetForm(formName) {
            this.$refs[formName].resetFields();
        }

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login_page {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .box_card {
        padding: 30px;
    }

    .login_title {
        font-size: 30px;
        font-weight: bold;
        text-align: center;
    }

    .login_form_box {
        margin-top: 20px;
        padding: 0 30px;
    }

    .el-form-item {
        margin-top: 20px;
        margin-bottom: 0 !important;
    }

    .getcode_box {
        font-size: 14px;
        color: #1664ff;
        padding: 15px 0;
        cursor: pointer;
    }
    .mt-50{
        margin-top: 50px;
    }
}
</style>
